import { apiErrorMessage, isDemoRejection } from '@/lib/formErrors'

export interface InviteFailure {
  email: string
  /** The API's reason ("User is already a member of this organization"), else a plain sentence. */
  message: string
}

/**
 * Sends one invite per address, one after another (the API takes one address per request), and
 * sorts the results: who was invited, and which addresses failed and why. A failure does not stop
 * the rest. The demo org's write block does: it is the same for every address, lib/api.ts has
 * already shown its toast, so it is passed on as it is for the dialog to show nothing more.
 */
export async function sendInvites<U>(
  emails: readonly string[],
  send: (email: string) => Promise<U>,
): Promise<{ invited: U[]; failed: InviteFailure[] }> {
  const invited: U[] = []
  const failed: InviteFailure[] = []
  for (const email of emails) {
    try {
      invited.push(await send(email))
    } catch (err) {
      if (isDemoRejection(err)) throw err
      failed.push({ email, message: apiErrorMessage(err, 'Couldn’t send this invite. Try again.') })
    }
  }
  return { invited, failed }
}
